import GetPaymentMethodsQuery from './PaymentMethods';

export default GetPaymentMethodsQuery;


// WEBPACK FOOTER //
// ./src/components/Query/PaymentMethods/index.ts